"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import s from "underscore.string";
import React from "react";
import { Link } from "../util/legacy_router";
import { FlashMessages } from "../components/flash_messages";
import Api from "../api/api";
import Auth from "../util/auth";
import { ErrorWithResponse } from "../util/fetch";
import ModuleDropdown from "../components/module_dropdown";
import AlertArea from "../components/alert_area";
import ErrorBoundary from "../components/error_boundary";
import LoadQuickSearch from "./load_quick_search";
import DashboardReturnLocation from "./ui/dashboard_return_location";
import ElmApp from "./elm-app";
import BeamerUpdates from "./beamer_updates";
import StaffBar from "../shared/staff_bar";
import {
  ManagedIndexerSwitcherOverlay,
  clearManagedIndexerSwitcher,
  managedIndexerHeaderAccounts,
  managedIndexerLegacySelect,
  restoreManagedIndexerSwitcher,
  startManagedIndexerSwitcher,
  stopManagedIndexerSwitcher
} from "./managed_indexer_switcher";
import Account from "../api/account";
import Reskin from "../helpers/reskin";
import { locationDescriptor } from "./app_history";
const isSandbox = () => {
  return Auth._currentUser && Auth._currentUser.account && !Auth._currentUser.account.demo && Auth._currentUser.account.sandbox || false;
};
const onScraperPage = (location) => {
  return location && location.pathname === "/to_be_scraped_loads";
};
function shouldHideNavbar(location) {
  if (!location || !location.pathname) return false;
  return location.pathname.match(/\/billing_requirements/) || location.pathname.match(/\/documents_viewer/) || location.pathname.match(/\/okta_login/);
}
function documentPageExists() {
  return "documentPage" in window;
}
function mainView(props) {
  var _a;
  return /* @__PURE__ */ jsx(
    ErrorBoundary,
    {
      name: "accounts-payable-page",
      resetKey: (_a = props.location) == null ? void 0 : _a.pathname,
      children: props.children
    }
  );
}
function mainViewContainerClass() {
  const v3ReskinReactStyleOverridesEnabledClasses = [
    "v3__theme",
    "audit_v3_reskin__activate_container",
    "v3_reskin__react-style-overrides-enabled"
  ];
  if (Reskin.getVals().indexAudit) {
    return v3ReskinReactStyleOverridesEnabledClasses.join(" ");
  } else {
    return "";
  }
}
function customAlertMessage() {
  if (Auth._currentUser && Auth._currentUser.account && Auth._currentUser.account.settings && Auth._currentUser.account.settings.custom_alert_message) {
    const message = Auth._currentUser.account.settings.custom_alert_message;
    return /* @__PURE__ */ jsx("div", { className: "alert-box alert-box--caution centered sandbox-warning", children: message });
  }
}
function logoutLink() {
  if (Auth.isAuthenticated()) {
    return /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(Link, { to: "/logout", children: "Log out" }) });
  }
}
function emailSearchLink() {
  if (Api.Account.currentSettings().email_search_account) {
    return /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(Link, { to: "/email_search", children: "Email Search" }) });
  }
}
function isHeldSubmissionPageEnabled() {
  const holdDays = Api.Account.currentSettings().ltl_hold_edi_import_days;
  return holdDays && holdDays > 0;
}
function heldSubmissionsLink() {
  if (isHeldSubmissionPageEnabled()) {
    return /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(Link, { to: "/held_submissions", children: "Held Submissions" }) });
  }
}
function hasSettingsRole() {
  return Auth.getCurrentUser() && !!Auth.getCurrentUser().settings_role;
}
function isDashboardReturnAccount() {
  return !!Account.isType("factor_account");
}
function switchUser(userId) {
  const current_user = Auth.getCurrentUser();
  if (current_user.id != userId) {
    Auth.switchUser(userId);
    return true;
  }
  return false;
}
function switchUserFromSelect(event) {
  switchUser(parseInt(event.target.value));
}
function groupUserOptions(group_user_info, current_user_id) {
  return group_user_info.map((row) => {
    return /* @__PURE__ */ jsx("option", { value: row["user_id"], children: row["account_name"] }, "group_user_" + row["user_id"]);
  });
}
function groupUsers() {
  var _a;
  if (Auth.isAuthenticated()) {
    const user = Auth.getCurrentUser();
    if (user.group_user_info && user.group_user_info.length > 0) {
      const managedIndexerSelect = managedIndexerLegacySelect(user);
      return /* @__PURE__ */ jsx("li", { className: "group-users-li", children: /* @__PURE__ */ jsx(
        "select",
        {
          className: "group-users-select",
          onChange: switchUserFromSelect,
          defaultValue: String(user.id),
          style: managedIndexerSelect == null ? void 0 : managedIndexerSelect.style,
          children: (_a = managedIndexerSelect == null ? void 0 : managedIndexerSelect.options) != null ? _a : groupUserOptions(user.group_user_info, user.id)
        },
        managedIndexerSelect ? "sections" : "plain"
      ) });
    }
  }
}
function account() {
  return Auth._currentUser && Auth._currentUser.account;
}
function isPayablesAccount() {
  const currentAccount = account();
  return currentAccount && currentAccount.payables_account;
}
function isIndexAuditSplitAccount() {
  const currentAccount = account();
  return currentAccount && currentAccount.index_audit_split_enabled;
}
function rememberDashboardDestination(location) {
  if (!isIndexAuditSplitAccount() || !location.pathname.includes("/dashboard") || !location.query["dashboardMode"]) {
    return;
  }
  let dashboardDestination;
  if (location.query["dashboardMode"] === "audit" && isPayablesAccount()) {
    dashboardDestination = "/dashboard/ready-to-audit";
  } else if (location.query["dashboardMode"] === "index" && !isPayablesAccount()) {
    dashboardDestination = "/dashboard/indexing";
  } else {
    dashboardDestination = "/dashboard/new";
  }
  localStorage.setItem("dashboardDestination", dashboardDestination);
}
function dashboardModeParams() {
  const dashboardDestination = localStorage.getItem("dashboardDestination");
  if (!isIndexAuditSplitAccount() || !dashboardDestination) {
    return {};
  }
  return {
    dashboardMode: dashboardDestination === "/dashboard/ready-to-audit" ? "audit" : "index"
  };
}
function dashboardLinkLocation() {
  if (isIndexAuditSplitAccount()) {
    const localStorageValue = localStorage.getItem("dashboardDestination");
    if (localStorageValue === "/dashboard/new" || localStorageValue === "/dashboard/ready-to-audit") {
      return localStorageValue;
    }
  }
  return Account.matchAccountType({
    broker: () => isPayablesAccount() ? "/dashboard" : "/to_be_scraped_loads",
    factor: () => "/dashboard",
    forwarder: () => "/dashboard"
  });
}
function dashboardQueuePath(route, dashboardMode) {
  const path = route || dashboardLinkLocation();
  return isDashboardReturnAccount() ? DashboardReturnLocation.queuePathFor(path, dashboardMode || "") : path;
}
function dashboardLinkTo(route, extraParams) {
  const params = extraParams || dashboardModeParams();
  const path = dashboardQueuePath(route, params.dashboardMode);
  return isDashboardReturnAccount() ? DashboardReturnLocation.appendTo(path, params) : DashboardReturnLocation.withParams(path, params);
}
function dashboardLinkUrl() {
  return dashboardLinkTo();
}
function headerDropdownPages() {
  const currentAccount = account();
  return {
    payables: !!(currentAccount && (currentAccount.payables_account || currentAccount.factor_account)),
    noaManagement: !!(currentAccount && currentAccount.settings.noa_management_enabled),
    receivables: !!(currentAccount && currentAccount.receivables_account && Auth._currentUser.receivables),
    insights: !!(currentAccount && // broker_account is a Ruby-side alias for payables_account? and is not
    // serialized, so this read is always undefined.
    (currentAccount["broker_account"] || currentAccount.settings.insights_dashboard_enabled) && Auth._currentUser.insights_dashboard_access),
    ltlDocRetrieval: !!(currentAccount && currentAccount.scraper_account),
    customerRep: !!(currentAccount && currentAccount.customer_representative_view_enabled && Auth._currentUser.customer_representative)
  };
}
function headerRightPages() {
  if (!Auth.isAuthenticated()) {
    return [];
  }
  const isIndexer = !!Auth.getCurrentUser().indexer;
  const isAuditor = !!Auth.getCurrentUser().auditor;
  const isAdmin = !!Auth.getCurrentUser().admin;
  const indexDashboardUrl = dashboardLinkTo(
    isPayablesAccount() ? "/app/dashboard/new" : "/app/dashboard/indexing",
    { dashboardMode: "index" }
  );
  const auditDashboardUrl = dashboardLinkTo(
    isPayablesAccount() ? "/app/dashboard/ready-to-audit" : "/app/dashboard/new",
    { dashboardMode: "audit" }
  );
  const indexQueuesLink = {
    title: "Index queues",
    url: indexDashboardUrl,
    isVisible: true,
    possibleLocationRegexes: [
      "^/app/dashboard$",
      "^/app/dashboard/new$",
      "^/app/dashboard.*dashboardMode=index",
      "^/app/index-document-batches"
    ]
  };
  const auditQueuesLink = {
    title: "Audit queues",
    url: auditDashboardUrl,
    isVisible: true,
    possibleLocationRegexes: [
      "^/app/dashboard.*dashboardMode=audit",
      "^/app/loads/"
    ]
  };
  let indexAuditLinks;
  if (isIndexAuditSplitAccount()) {
    if (isIndexer && isAuditor || isAdmin) {
      indexAuditLinks = [indexQueuesLink, auditQueuesLink];
    } else if (isIndexer) {
      indexQueuesLink.title = "Queues";
      indexQueuesLink.possibleLocationRegexes.push("^/app/dashboard");
      indexAuditLinks = [indexQueuesLink];
    } else if (isAuditor) {
      auditQueuesLink.title = "Queues";
      auditQueuesLink.possibleLocationRegexes.push("^/app/dashboard");
      indexAuditLinks = [auditQueuesLink];
    } else {
      indexAuditLinks = [];
    }
  } else {
    indexQueuesLink.title = "Queues";
    indexQueuesLink.possibleLocationRegexes.push("^/app/dashboard");
    indexQueuesLink.url = dashboardLinkUrl();
    indexAuditLinks = [indexQueuesLink];
  }
  const links = indexAuditLinks.concat([
    {
      title: "Email search",
      url: "/app/email_search",
      isVisible: Api.Account.currentSettings().email_search_account,
      possibleLocationRegexes: ["^/app/email_search", "^/app/email/"]
    },
    {
      title: "Activity",
      url: "/app/activity",
      isVisible: true,
      possibleLocationRegexes: ["^/app/activity"]
    },
    {
      title: "Held submissions",
      url: "/app/held_submissions",
      isVisible: isHeldSubmissionPageEnabled(),
      possibleLocationRegexes: ["^/app/held_submissions"]
    }
  ]);
  return links.filter((link) => link.isVisible).map((link) => {
    return {
      title: link.title,
      url: link.url,
      possibleLocationRegexes: link.possibleLocationRegexes
    };
  });
}
function indexDashboardLink(label) {
  const route = isPayablesAccount() ? "/dashboard/new" : "/dashboard/indexing";
  return /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(
    Link,
    {
      to: dashboardLinkTo(route, { dashboardMode: "index" }),
      onClick: () => isIndexAuditSplitAccount() && localStorage.setItem("dashboardDestination", route),
      children: label
    }
  ) });
}
function auditDashboardLink(label) {
  const route = isPayablesAccount() ? "/dashboard/ready-to-audit" : "/dashboard/new";
  return /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(
    Link,
    {
      to: dashboardLinkTo(route, { dashboardMode: "audit" }),
      onClick: () => isIndexAuditSplitAccount() && localStorage.setItem("dashboardDestination", route),
      children: label
    }
  ) });
}
function indexAuditDropdownMenu() {
  return /* @__PURE__ */ jsx("ul", { className: "left", id: "module-dropdown", children: /* @__PURE__ */ jsxs("li", { className: "has-dropdown not-click", children: [
    /* @__PURE__ */ jsx("a", { children: "Dashboard" }),
    /* @__PURE__ */ jsxs("ul", { className: "dropdown", children: [
      indexDashboardLink("Index"),
      auditDashboardLink("Audit")
    ] })
  ] }) });
}
function headerFlagsForElm(props) {
  var _a;
  let accounts = [];
  if (Auth.isAuthenticated()) {
    const user = Auth.getCurrentUser();
    if (user.group_user_info && user.group_user_info.length > 0) {
      accounts = (_a = managedIndexerHeaderAccounts(user)) != null ? _a : user.group_user_info.map((group_user) => {
        return {
          id: group_user["user_id"],
          name: group_user["account_name"],
          isCurrent: group_user["user_id"] === user.id
        };
      });
    }
  }
  return {
    reskinVals: Reskin.getVals(),
    showNavBar: !shouldHideNavbar(props.location),
    reskinUserToggle: Reskin.getReskinUserToggle(),
    dashboardLinkLocation: dashboardLinkUrl(),
    headerDropdownPages: headerDropdownPages(),
    headerRightPages: headerRightPages(),
    hasSettingsRole: !!hasSettingsRole(),
    isFactor: !!Account.hasRole("Factor"),
    accounts
  };
}
function sandboxMessage(props) {
  if (isSandbox() && !onScraperPage(props.location)) {
    const loadEmailSandboxRecipients = Api.Account.loadEmailSandboxRecipients();
    let message = "This account is currently in sandbox mode. No invoices will be sent to external systems.";
    if (loadEmailSandboxRecipients) {
      message += " All emails will go to " + s.toSentenceSerial(loadEmailSandboxRecipients, ", ") + ".";
    }
    return /* @__PURE__ */ jsx("div", { className: "alert-box warning centered sandbox-warning", children: message });
  }
}
function dashboardParams(props) {
  if (!isDashboardReturnAccount() && (props.location.pathname === "/dashboard" || props.location.pathname === "/dashboard/new")) {
    return props.location.query;
  }
}
function navbarDashboardLinkTo(props) {
  return dashboardParams(props) ? dashboardQueuePath(null, dashboardModeParams().dashboardMode) : dashboardLinkTo();
}
function dashboardLinkOrDropdown(props) {
  const isIndexer = !!Auth.getCurrentUser().indexer;
  const isAuditor = !!Auth.getCurrentUser().auditor;
  const isAdmin = !!Auth.getCurrentUser().admin;
  if (isIndexAuditSplitAccount()) {
    if (isIndexer && isAuditor || isAdmin) {
      return indexAuditDropdownMenu();
    } else if (isIndexer) {
      return indexDashboardLink("Dashboard");
    } else if (isAuditor) {
      return auditDashboardLink("Dashboard");
    } else {
      return dashboardLink(props);
    }
  } else {
    return dashboardLink(props);
  }
}
function dashboardLink(props) {
  return /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(
    Link,
    {
      to: locationDescriptor(
        navbarDashboardLinkTo(props),
        dashboardParams(props)
      ),
      children: "Dashboard"
    }
  ) });
}
class App extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "lastDashboardHeaderLinkUrls");
    __publicField(this, "staffBarRef", React.createRef());
    __publicField(this, "elmAppRef", React.createRef());
    __publicField(this, "updateAuth", (loggedIn) => {
      var _a;
      const justSignedIn = loggedIn && !this.state.loggedIn;
      if (!loggedIn) clearManagedIndexerSwitcher();
      this.setState({
        loggedIn
      });
      (_a = this.elmAppRef.current) == null ? void 0 : _a.updateHeaderFlags(headerFlagsForElm(this.props));
      if (justSignedIn) startManagedIndexerSwitcher(this.refreshAccountSwitcher);
    });
    // The managed indexer account switcher has new SLA stats for both headers.
    __publicField(this, "refreshAccountSwitcher", () => {
      var _a;
      (_a = this.elmAppRef.current) == null ? void 0 : _a.updateHeaderFlags(headerFlagsForElm(this.props));
      this.forceUpdate();
    });
    __publicField(this, "rightTopBarLinks", () => {
      if (Auth.isAuthenticated()) {
        return /* @__PURE__ */ jsxs("ul", { className: "right", children: [
          /* @__PURE__ */ jsx("li", { id: "load-quick-search", className: "has_form", children: /* @__PURE__ */ jsx(LoadQuickSearch, { location: this.props.location }) }),
          dashboardLinkOrDropdown(this.props),
          heldSubmissionsLink(),
          /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(Link, { to: "/activity", children: "Activity" }) }),
          emailSearchLink(),
          this.settingsLink(),
          /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(Link, { to: "/help", children: "Help" }) }),
          /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(BeamerUpdates, {}) }),
          groupUsers(),
          logoutLink()
        ] });
      }
    });
    __publicField(this, "navbar", () => {
      if (!shouldHideNavbar(this.props.location)) {
        return /* @__PURE__ */ jsxs("nav", { className: "top-bar main-nav", "data-topbar": true, role: "navigation", children: [
          /* @__PURE__ */ jsx("ul", { className: "title-area show-for-large-up", children: /* @__PURE__ */ jsx("li", { className: "name", children: /* @__PURE__ */ jsx("h1", { children: /* @__PURE__ */ jsx(
            Link,
            {
              to: locationDescriptor(
                navbarDashboardLinkTo(this.props),
                dashboardParams(this.props)
              ),
              children: /* @__PURE__ */ jsx(
                "img",
                {
                  style: {
                    borderRadius: "4px",
                    background: "rgba(255, 255, 255, 0.40)",
                    padding: "4px"
                  },
                  src: "/assets/TriumphLogo.svg",
                  className: "hubtran-logo"
                }
              )
            }
          ) }) }) }),
          /* @__PURE__ */ jsxs("section", { className: "top-bar-section", children: [
            /* @__PURE__ */ jsx(ModuleDropdown, { location: this.props.location }),
            this.rightTopBarLinks()
          ] })
        ] });
      }
    });
    __publicField(this, "settingsLink", () => {
      const userHasSettingsRole = hasSettingsRole();
      const reskinToggleVisible = Reskin.getReskinUserToggle() != null;
      if (reskinToggleVisible) {
        const switchStr = "Beginning May 26, 2026, Triumph Audit will no longer support our previous experience and layout.";
        return /* @__PURE__ */ jsx("ul", { id: "module-dropdown", children: /* @__PURE__ */ jsxs("li", { className: "has-dropdown not-click", children: [
          /* @__PURE__ */ jsx("a", { children: "Settings" }),
          /* @__PURE__ */ jsxs("ul", { className: "dropdown", style: { right: "auto" }, children: [
            userHasSettingsRole && /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(Link, { to: "/settings", children: "Account Settings" }) }),
            /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsxs(
              "a",
              {
                style: { padding: "18px", lineHeight: "150%" },
                onClick: () => this.toggleReskinFromNavBar(
                  !this.state.reskinToggleValFromNavBar
                ),
                "data-fullstory-reskin-toggle": "enable",
                children: [
                  /* @__PURE__ */ jsxs(
                    "div",
                    {
                      style: {
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "12px"
                      },
                      children: [
                        /* @__PURE__ */ jsx("div", { children: "Layout Preferences" }),
                        /* @__PURE__ */ jsx(
                          "div",
                          {
                            style: {
                              borderRadius: "16px",
                              color: "rgb(0, 124, 143)",
                              fontSize: "12px",
                              lineHeight: "12px",
                              border: "1px solid rgb(186, 239, 247)",
                              backgroundColor: "rgb(250, 250, 250)",
                              padding: "4px 8px 2px"
                            },
                            children: "New"
                          }
                        )
                      ]
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    "div",
                    {
                      style: {
                        whiteSpace: "break-spaces",
                        fontSize: "12px",
                        minWidth: "220px"
                      },
                      children: switchStr
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    "div",
                    {
                      style: {
                        color: "rgb(152, 229, 240)",
                        fontSize: "12px"
                      },
                      children: "Switch Layout"
                    }
                  )
                ]
              }
            ) })
          ] })
        ] }) });
      } else if (userHasSettingsRole) {
        return /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(Link, { to: "/settings", children: "Settings" }) });
      }
    });
    // Elm holds its header flags in its own model, so a filter change has to be
    // pushed back over the port for the Elm header's Dashboard links to pick up
    // the new filters. Only re-send when a link URL actually changed, so a burst
    // of filter edits doesn't churn the Elm header.
    __publicField(this, "refreshDashboardHeaderLinks", () => {
      const elmApp = this.elmAppRef.current;
      if (!elmApp) return;
      const flags = headerFlagsForElm(this.props);
      const linkUrls = JSON.stringify([
        flags.dashboardLinkLocation,
        flags.headerRightPages.map((page) => page.url)
      ]);
      if (linkUrls === this.lastDashboardHeaderLinkUrls) return;
      this.lastDashboardHeaderLinkUrls = linkUrls;
      elmApp.updateHeaderFlags(flags);
    });
    __publicField(this, "refreshStaffBar", () => {
      var _a;
      (_a = this.staffBarRef.current) == null ? void 0 : _a.refreshLocation();
    });
    __publicField(this, "toggleReskinFromStaffBar", (val) => {
      var _a;
      this.setState({ reskinToggleValFromStaffBar: val });
      Reskin.saveToggle(val);
      (_a = this.elmAppRef.current) == null ? void 0 : _a.updateHeaderFlags(headerFlagsForElm(this.props));
    });
    __publicField(this, "toggleReskinFromNavBar", (enabled) => {
      var _a;
      const newVal = enabled;
      Reskin.saveToggleUser(newVal);
      this.setState({ reskinToggleValFromNavBar: newVal });
      (_a = this.elmAppRef.current) == null ? void 0 : _a.updateHeaderFlags(headerFlagsForElm(this.props));
    });
    const loggedIn = Auth.isAuthenticated();
    this.state = {
      loggedIn,
      reskinToggleValFromStaffBar: Reskin.getSavedToggle(),
      reskinToggleValFromNavBar: Reskin.getReskinUserToggle()
    };
    rememberDashboardDestination(props.location);
    restoreManagedIndexerSwitcher();
  }
  componentWillUnmount() {
    stopManagedIndexerSwitcher();
  }
  componentDidMount() {
    startManagedIndexerSwitcher(this.refreshAccountSwitcher);
    Auth.onChange = this.updateAuth;
    if (!Auth.isAuthenticated()) {
      Auth.currentUser().catch((error) => {
        if (!(error instanceof ErrorWithResponse) || error.response.status !== 401) {
          throw error;
        }
      });
    }
  }
  render() {
    if (documentPageExists()) {
      return /* @__PURE__ */ jsxs("div", { id: "mainViewContainer", "data-component": "App", children: [
        sandboxMessage(this.props),
        mainView(this.props)
      ] });
    } else {
      const elmHeaderFlags = headerFlagsForElm(this.props);
      const hideLegacyNavbar = shouldHideNavbar(this.props.location) || Reskin.getVals().topLevel;
      const legacyNavbar = hideLegacyNavbar ? null : this.navbar();
      return /* @__PURE__ */ jsxs("div", { className: "react-wrapper", "data-component": "App", children: [
        /* @__PURE__ */ jsx(
          StaffBar,
          {
            ref: this.staffBarRef,
            currentUser: Auth._currentUser,
            loggedIn: this.state.loggedIn,
            toggleReskin: (evt) => this.toggleReskinFromStaffBar(evt.target.value),
            reskinToggleVal: this.state.reskinToggleValFromStaffBar,
            onUpdate: () => {
              var _a;
              return (_a = this.elmAppRef.current) == null ? void 0 : _a.headerMoved();
            }
          }
        ),
        /* @__PURE__ */ jsx(ManagedIndexerSwitcherOverlay, {}),
        /* @__PURE__ */ jsx("div", { className: "contain-to-grid", children: legacyNavbar }),
        /* @__PURE__ */ jsx(AlertArea, {}),
        /* @__PURE__ */ jsxs("div", { id: "container", children: [
          /* @__PURE__ */ jsx("div", { id: "flash-messages", children: /* @__PURE__ */ jsx(FlashMessages, {}) }),
          /* @__PURE__ */ jsxs("div", { children: [
            customAlertMessage(),
            sandboxMessage(this.props)
          ] }),
          /* @__PURE__ */ jsx("div", { id: "elm-container", children: /* @__PURE__ */ jsx(
            ElmApp,
            {
              ref: this.elmAppRef,
              location: this.props.location,
              headerFlags: elmHeaderFlags,
              switchUserCallback: switchUser,
              toggleReskin: this.toggleReskinFromNavBar,
              dashboardFiltersChanged: this.refreshDashboardHeaderLinks,
              urlChanged: this.refreshStaffBar
            }
          ) }),
          /* @__PURE__ */ jsx("div", { id: "mainViewContainer", className: mainViewContainerClass(), children: mainView(this.props) })
        ] })
      ] });
    }
  }
}
export default App;
